import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { dismissOutdatedDevicesAlert, toggleOutdatedDevicesAlertExpand } from '../../app/appActions';
import { OutdatedDevicesAlert } from '../presentationalComponents/OutdatedDevicesAlert';
import { getIsAlertDismissed, getDevices, getShouldExpandAlert, showAlertSelector } from '../reduxUpdater/selectors/outdatedDevicesAlertSelector';
import { getOutdatedDevicesAlertStyles } from '../styles/outdatedDevicesAlertStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    callingComponent: _ownProps.callingComponent,
    devices: getDevices(state, _ownProps.callingComponent),
    shouldShowOutdatedDevicesAlert: state.ContactState.SharedState.shouldShowOutdatedDevicesAlert,
    isOutdatedDevicesAlertDismissed: getIsAlertDismissed(state, _ownProps.callingComponent),
    shouldExpandOutdatedDevicesAlert: getShouldExpandAlert(state, _ownProps.callingComponent),
    showAlert: showAlertSelector(state, _ownProps.callingComponent),
    deviceMinCountToShowExpandIcon: state.ContactState.SharedState.deviceMinCountToShowExpandIcon,
    deviceMaxCount: state.ContactState.SharedState.deviceMaxCount,
    howToUpdateWindowsUrl: state.ContactState.SharedState.howToUpdateWindowsUrl,
    windowsUpdateInvokingUrl: state.ContactState.SharedState.windowsUpdateInvokingUrl,
  };
};

const mapDispatchToProps = {
  dismissOutdatedDevicesAlert,
  toggleOutdatedDevicesAlertExpand,
};

export const OutdatedDevicesAlertContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(OutdatedDevicesAlert, getOutdatedDevicesAlertStyles));
